export default __webpack_public_path__ + "static/media/quesionmark.dd3833cf.jpg";